import { render, staticRenderFns } from "./U8salesorderreporttable.vue?vue&type=template&id=4dfb5827&scoped=true&"
import script from "./U8salesorderreporttable.vue?vue&type=script&lang=js&"
export * from "./U8salesorderreporttable.vue?vue&type=script&lang=js&"
import style0 from "./U8salesorderreporttable.vue?vue&type=style&index=0&id=4dfb5827&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb5827",
  null
  
)

export default component.exports